// Basemap tiles for every Leaflet map. Stadia authenticates by the requesting
// domain (registered in the Stadia dashboard), so no key lives here; localhost
// works without registration.
export const MAP_TILE_URL = 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png';

export const MAP_TILE_ATTRIBUTION =
  '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
